module.exports = __webpack_public_path__ + "pcsg/img/productlist-02.75e64c92.jpg";